import { useEffect, useCallback, useMemo, DependencyList } from 'react';
import Activity from '../../services/activity/Activity';

const useActivity = (
  callback: () => void,
  deps: DependencyList,
  options?: { frequency?: number; strategy?: 'trailing' | 'leading' },
) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const callbackRef = useCallback(callback, deps);

  const cachedOptions = useMemo(() => ({
    frequency: options?.frequency,
    strategy: options?.strategy,
  }), [options?.frequency, options?.strategy]);

  useEffect(() => (
    Activity.watch(callbackRef, cachedOptions)
  ), [callbackRef, cachedOptions]);
};

/**
 * @visibleName useActivity
 * @component
 */
export default useActivity;
